import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/styles';
import {
  TextField,
  Grid,
  CardHeader,
  Divider,
  Button,
  Fab,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import SaveIcon from '@material-ui/icons/Save';
import RTL from '../../../../components/RTL';
import province from './../../../province';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {Loading, showSnackbar} from 'redux/Action';
import {useDispatch, useSelector} from 'react-redux';
import {axios} from './../../../../axios';
import {values} from 'underscore';
const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: 'auto',
    position: 'relative',
    overflow: 'unset',
  },
  inputBtn: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  imageButton: {
    position: 'absolute',
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
    width: '100%',
  },
  imageInput: {
    display: 'none',
  },
  divider: {
    opacity: '0.1',
    marginLeft: '25%',
    marginRight: '25%',
    width: '50%',
    alignItems: 'center',
    backgroundColor: '#273c75',
    height: 1,
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  wrapper: {
    position: 'relative',
    width: '100%',
  },
  buttonProgress: {
    color: '#121E3E',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: -12,
  },
}));

const Form = (props) => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.token);
  const isLoading = useSelector((state) => state.isLoading);


  var
  persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
  arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g],
  fixNumbers = function (str)
  {
    if(typeof str === 'string')
    {
      for(var i=0; i<10; i++)
      {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      } 
    }
    return str;
  };


  
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const {data, id, edit, reloadFunc, onClose} = props;
  const [city, setCity] = useState('');
  const [cityId, setCityId] = useState('');

  const classes = useStyles();

  const [cities, setCities] = useState([]);
  const [error, setError] = React.useState({
    name: '',
    address: '',
    tell: '',
    city_id: '',
    reg_number: '',
  });
  const [value, setValue] = React.useState({
    name: '',
    address: '',
    tell: '',
    city_id: '',
    reg_number: '',
  });
  let id_sel_edit = edit ? data[0].city_id : '';

  const Get_Data_Sel = async () => {
    try {
      const res = await axios.get(`companies/${id}`, {
        headers: headers,
      });

      setValue({
        ...value,
        name: res.data.data?.company?.name,
        address: res.data.data?.company?.address,
        city_id: res.data.data?.company?.city?.county_id,
        reg_number: res.data.data?.company?.reg_number,
        tell: res.data.data?.company?.tell,
      });
      setCity(res.data.data?.company?.city?.name);

      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }
  };

  const Get_Component = async () => {
    try {
      const res = await axios.get('companies/create', {
        headers: headers,
      });
      setCities(res.data.cities);
      if (edit) {
        Get_Data_Sel();
        dispatch(Loading());
      }

      // console.log(res.data.cities,"axx")
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      // console.log(e.response, 'eeeeeeeee');
    }
  };

  useEffect(() => {
    Get_Component();
    dispatch(Loading());
  }, []);

  const handleChange = (e) => {
    const re = /^[0-9\b]+$/;

    let name = e.target.name;
    setError({...error, [name]: ''});

    switch (name) {
      case 'tell':
        if (fixNumbers(e.target.value) === '' || re.test(fixNumbers(e.target.value))) {
          if (e.target.value.length < 12) {
            setValue({...value, [name]: fixNumbers(e.target.value)});
            setError({...error, [name]: ''});
          }
        } else {
          setError({...error, [name]: 'شماره تماس فقط بصورت عدد می باشد'});
        }
        break;

      // case 'manager_cell':
      //   if (e.target.value === '' || re.test(e.target.value)) {
      //     if (e.target.value.length < 12) {
      //       setValue({...value, [name]: e.target.value});
      //       setError({...error, [name]: ''});
      //     }
      //   } else {
      //     setError({...error, [name]: 'شماره موبایل فقط بصورت عدد می باشد'});
      //   }
      //   break;

      case 'reg_number':
        if (fixNumbers(e.target.value) === '' || re.test(fixNumbers(e.target.value))) {
          setValue({...value, [name]: fixNumbers(e.target.value)});
          setError({...error, [name]: ''});
        } else {
          setError({...error, [name]: 'شماره ثبت شغل فقط بصورت عدد می باشد'});
        }
        break;

      default:
        setValue({...value, [name]: e.target.value});

        break;
    }

    // setValue({
    //   ...value,
    //   [event.target.name]: event.target.value,
    // });
  };

  const InsertCompany = async () => {
    try {
      const res = await axios.post(
        'companies',
        {
          name: value.name,
          address: value.address,
          tell: value.tell,
          city_id: value.city_id,
          reg_number: value.reg_number,
        },
        {
          headers: headers,
        }
      );
      dispatch(showSnackbar(true, 'success', 'شغل جدید با موفقیت ثبت شد'));
      setValue({
        ...value,
        name: '',
        address: '',
        tell: '',
        city_id: '',
        reg_number: '',
      });
      setCity('');
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      // console.log(e.response, 'eeeeeeeee');
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {
          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }
  };

  const UpdateCompany = async () => {
    try {
      const res = await axios.post(
        `companies/${id}`,
        {
          name: value.name,
          address: value.address,
          tell: value.tell,
          city_id: value.city_id,
          reg_number: value.reg_number,
          _method: 'patch',
        },
        {
          headers: headers,
        }
      );
      dispatch(showSnackbar(true, 'success', 'شغل با موفقیت بروزرسانی شد'));
      setValue({
        ...value,
        name: '',
        address: '',
        tell: '',
        city_id: '',
        reg_number: '',
      });
      setCity('');
      reloadFunc();
      onClose();
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
      // console.log(e.response, 'eeeeeeeee');
      if (e.response.status === 422) {
        const er = e.response.data.errors;

        let er_keys = Object.keys(er);
        let obj_error = {};
        er_keys.forEach((element) => {
          obj_error[element] = er[element][0];
        });

        setError(obj_error);
      }
    }
  };

  const sendBtn = () => {
    let va_keys = Object.keys(value);

    let obj_empty = {};
    va_keys.forEach((element) => {
      // if(element=='manager_cell')
      // {
      //   if(value.manager_cell.length!=11)
      //   {
      //     obj_empty[element] = "تعداد ارقام شماره موبایل صحیح نمی باشد";

      //   }
      // }
      // else
      if (element == 'tell') {
          if (value.tell.length != 11) {
            obj_empty[element] = 'تعداد ارقام شماره تماس صحیح نمی باشد';
          }
        
      } else if (value[element] === '') {
        obj_empty[element] = 'این فیلد نمی تواند خالی باشد';
      }
    });

    setError(obj_empty);

    if (Object.keys(obj_empty).length == 0) {
      if (edit) {
        dispatch(Loading());
        UpdateCompany();
      } else {
        dispatch(Loading());
        InsertCompany();
      }
    } else {
      // alert(JSON.stringify(obj_empty))
    }
  };

  return (
    <RTL>
      {!isLoading ? (
        <>
          {edit ? (
            <Grid justify="center" container>
              <CardHeader title="ویرایش شغل " />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>
          ) : (
            <Grid justify="center" container>
              <CardHeader title="ثبت شغل جدید" />
              <Divider className={classes.divider} variant="fullWidth" />
            </Grid>
          )}

          <Grid container justify="space-between">
            <Grid item xs={12} sm={5}>
              <TextField
                className={classes.input}
                label="نام شغل"
                variant="outlined"
                value={value.name}
                error={Boolean(error?.name)}
                helperText={error?.name}
                onChange={handleChange}
                name="name"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={classes.input}
                label="شماره ثبت "
                variant="outlined"
                value={value.reg_number}
                error={Boolean(error?.reg_number)}
                helperText={error?.reg_number}
                onChange={handleChange}
                name="reg_number"
              />
            </Grid>
          </Grid>

          <Grid container justify="space-between">
            <Grid item xs={12} sm={5}>
              <Autocomplete
                id="TypeContract"
                noOptionsText="همچنین شهری وجود ندارد"
                options={cities}
                groupBy={(option) => option.get_province?.name}
                getOptionLabel={(option) => option.name}
                onChange={(event, val) =>
                  val !== null
                    ? ` ${setValue({...value, city_id: val.id})} ${setCity(
                        val.get_province?.name
                      )} ${setError({...error, city_id: ''})}`
                    : ''
                }
                defaultValue={{
                  name: ` ${city}`,
                }}
                renderInput={(params) => (
                  <TextField
                    className={classes.input}
                    {...params}
                    label="شهر "
                    variant="outlined"
                    error={Boolean(error?.city_id)}
                    helperText={error?.city_id}
                  />
                )}
              />
              <Typography variant="caption">{city}</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                className={classes.input}
                label="شماره تماس "
                variant="outlined"
                value={value.tell}
                error={Boolean(error?.tell)}
                helperText={error?.tell}
                onChange={handleChange}
                name="tell"
              />
            </Grid>
          </Grid>

          <TextField
            multiline
            className={classes.input}
            label="آدرس"
            fullWidth
            variant="outlined"
            rows="4"
            value={value.address}
            error={Boolean(error?.address)}
            helperText={error?.address}
            onChange={handleChange}
            name="address"
          />

          {edit ? (
            <div className={classes.wrapper}>
              <Button
                fullWidth
                className={(classes.input, classes.inputBtn)}
                variant="contained"
                color="secondary"
                disabled={isLoading}
                onClick={() => sendBtn()}
                size="large"
                startIcon={<SaveIcon className={classes.submitButtonIcon} />}
              >
                بروزرسانی شغل
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          ) : (
            <div className={classes.wrapper}>
              <Button
                fullWidth
                onClick={() => sendBtn()}
                className={(classes.input, classes.inputBtn)}
                variant="contained"
                disabled={isLoading}
                color="secondary"
                size="large"
                startIcon={<SaveIcon className={classes.submitButtonIcon} />}
              >
                ثبت شغل جدید
              </Button>
              {isLoading && (
                <CircularProgress
                  size={24}
                  className={classes.buttonProgress}
                />
              )}
            </div>
          )}
        </>
      ) : (
        <div className={classes.wrapper} style={{padding: 40}}>
          {isLoading && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
        </div>
      )}
    </RTL>
  );
};

export default Form;
